<template>
  <div>
    <!-- 訂購人 -->
    <v-card class="mb-3">
      <v-list-item>
        <v-list-item-content>{{$t('addressInput_title1')}}</v-list-item-content>
        <v-list-item-action>
          <v-dialog
            v-model="show_area.order_dialog"
            persistent
            width="500"
          >
            <template v-slot:activator="{ on }">
              <v-btn text color="error" v-on="on" v-show="!show_area.order_is_first">
                {{$t('edit_button')}}
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">{{$t('addressInput_title3')}}</v-card-title>
              <v-card-text id="order_data">
                <v-text-field
                  :label="$t('name_input')"
                  :placeholder="$t('addressInput_input1')"
                  v-model="edit_user_info[0].name">
                </v-text-field>
                <v-text-field
                  :label="$t('email_input')"
                  :placeholder="$t('addressInput_input2')"
                  v-model="edit_user_info[0].email"
                ></v-text-field>
                <v-text-field
                  :label="$t('phone_input')"
                  :placeholder="$t('addressInput_input3')"
                  v-model="edit_user_info[0].mobile"
                ></v-text-field>
                <div v-show="!is_vending_machine">
                  <v-input style="margin-bottom: -30px;">{{$t('addressInput_input8')}}</v-input>
                  <div v-show="!show_area.order_one_address">
                    <v-radio-group v-model="edit_user_info[0].address_type" @change="onOrderChange($event)">
                      <v-radio
                        :label="$t('addressInput_input4')"
                        value="2"
                        v-show="edit_user_info[0].company_exist"
                      ></v-radio>
                      <v-radio
                        :label="$t('addressInput_input5')"
                        value="1"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                  <div v-show="show_area.order_company_show">
                    <v-text-field
                      v-model="edit_user_info[0].company_address"
                      :label="$t('addressInput_input6')"
                    ></v-text-field>
                    <v-text-field
                      v-model="edit_user_info[0].company_name"
                      :label="$t('addressInput_input7')"
                    ></v-text-field>
                  </div>
                  <div v-show="show_area.order_home_show">
                    <v-row align="center">
                      <v-col class="d-flex" cols="6">
                        <div class="select_sty">
                          <select v-model="edit_user_info[0].city" @change="onOrderAreaChange">
                            <option value="">{{$t('addressInput_text1')}}</option>
                            <option v-for="product in area.area_lists" :key="product">
                              {{ product }}
                            </option>
                          </select>
                        </div>
                      </v-col>
                      <v-col class="d-flex" cols="6">
                        <div class="select_sty">
                          <select v-model="edit_user_info[0].area">
                            <option value="">{{$t('addressInput_text2')}}</option>
                            <option v-for="detail in area.area_detail[edit_user_info[0].city]" :key="detail">{{ detail }}</option>
                          </select>
                        </div>
                      </v-col>
                    </v-row>
                    <p>{{$t('addressInput_text3')}}</p>
                    <v-text-field
                      v-model="edit_user_info[0].address"
                      :label="$t('addressInput_input8')"
                    ></v-text-field>
                  </div>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="show_area.order_dialog = false;"
                >
                  {{$t('cancel_button')}}
                </v-btn>
                <v-btn
                  color="primary"
                  @click="checkOrderAddress"
                >
                  {{$t('ok_button2')}}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-list-item-action>
      </v-list-item>
      <v-divider></v-divider>
      <div class="text-center mt-3">
        <v-btn
          outlined
          color="error"
          @click="show_area.order_dialog = true;"
          v-show="show_area.order_is_first"
        >
          <v-icon left>mdi-pencil</v-icon> {{$t('addressInput_button1')}}
        </v-btn>
      </div>
      <div v-show="!show_area.order_is_first">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{$t('name_input')}}：{{ user_info[0].name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{$t('phone_input')}}：{{ user_info[0].mobile }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{$t('email_input')}}：{{ user_info[0].email }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-show="!is_vending_machine">
          <v-list-item-content>
            <v-list-item-title>{{$t('address_input')}}：{{ maxaddress.order_max_address }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-card>
    <!-- 收貨人 -->
    <v-card class="mb-3">
      <v-list-item>
        <v-list-item-content>{{$t('addressInput_title2')}}</v-list-item-content>
        <v-list-item-action>
          <v-dialog
            v-model="show_area.rec_dialog"
            persistent
            width="500"
          >
            <template v-slot:activator="{ on }">
              <v-btn text color="error" v-on="on" v-show="!show_area.rec_is_first">
                {{$t('edit_button')}}
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">{{$t('addressInput_title4')}}</v-card-title>
              <v-card-text>
                <v-text-field
                  :label="$t('name_input')"
                  :placeholder="$t('addressInput_input1')"
                  v-model="edit_user_info[0].rec_name"
                ></v-text-field>
                <v-text-field
                  :label="$t('email_input')"
                  :placeholder="$t('addressInput_input2')"
                  v-model="edit_user_info[0].rec_email"
                ></v-text-field>
                <v-text-field
                  :label="$t('phone_input')"
                  :placeholder="$t('addressInput_input3')"
                  v-model="edit_user_info[0].rec_mobile"
                ></v-text-field>
                <div v-show="is_vending_machine">
                  <p>取貨人出示取貨 QR Code 至新竹智邦1樓智販機取貨。</p>
                </div>
                <div v-show="!is_vending_machine">
                  <v-input style="margin-bottom: -30px;">{{$t('addressInput_input9')}}</v-input>
                  <div v-show="!show_area.rec_one_address">
                    <v-radio-group v-model="edit_user_info[0].rec_address_type" @change="onRecChange($event)">
                      <v-radio
                        :label="$t('addressInput_input4')"
                        value="2"
                        v-show="edit_user_info[0].company_exist"
                      ></v-radio>
                      <v-radio
                        :label="$t('addressInput_input5')"
                        value="1"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                  <div v-show="show_area.rec_company_show">
                    <v-text-field
                      v-model="edit_user_info[0].rec_company_address"
                      :label="$t('addressInput_input6')"
                    ></v-text-field>
                    <v-text-field
                      v-model="edit_user_info[0].rec_company_name"
                      :label="$t('addressInput_input7')"
                    ></v-text-field>
                  </div>
                  <div v-show="show_area.rec_home_show">
                    <v-row align="center">
                      <v-col class="d-flex" cols="6">
                        <div class="select_sty">
                          <select v-model="edit_user_info[0].rec_city" @change="onRecAreaChange">
                            <option value="">{{$t('addressInput_text1')}}</option>
                            <option v-for="product in area.area_lists" :key="product">
                              {{ product }}
                            </option>
                          </select>
                        </div>
                      </v-col>
                      <v-col class="d-flex" cols="6">
                        <div class="select_sty">
                          <select v-model="edit_user_info[0].rec_area">
                            <option value="">{{$t('addressInput_text2')}}</option>
                            <option v-for="detail in area.area_detail[edit_user_info[0].rec_city]" :key="detail">{{ detail }}</option>
                          </select>
                        </div>
                      </v-col>
                    </v-row>
                    <p>{{$t('addressInput_text3')}}</p>
                    <v-text-field
                      v-model="edit_user_info[0].rec_address"
                      :label="$t('addressInput_input8')"
                    ></v-text-field>
                  </div>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="show_area.rec_dialog = false;"
                >
                  {{$t('cancel_button')}}
                </v-btn>
                <v-btn
                  color="primary"
                  @click="checkRecAddress"
                >
                  {{$t('ok_button2')}}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <!-- v-model="order_checkbox" -->
          <!-- @change="SameOrderData" -->
          <v-checkbox
            :label="$t('addressInput_button3')"
            @change="sameOrderData"
          ></v-checkbox>
        </v-list-item-action>
      </v-list-item>
      <v-divider></v-divider>
      <div class="text-center mt-3">
        <v-btn
          outlined
          color="error"
          @click="show_area.rec_dialog = true"
          v-show="show_area.rec_is_first"
        >
          <v-icon left>mdi-pencil</v-icon> {{$t('addressInput_button2')}}
        </v-btn>
      </div>
      <div v-show="!show_area.rec_is_first">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{$t('name_input')}}：{{ user_info[0].rec_name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{$t('phone_input')}}：{{ user_info[0].rec_mobile }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{$t('email_input')}}：{{ user_info[0].rec_email }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-show="!is_vending_machine">
          <v-list-item-content>
            <v-list-item-title>{{$t('address_input')}}：{{ maxaddress.rec_max_address }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'addressInput',
  props: ['getuserinfodata', 'onlyoneaddress', 'getisvendingmachine'],

  data: function () {
    return {
      access_key: 'rIhTQzuOwZ54asxqRMNkYVF3n6UA7v9c',
      user_uuid: '',
      group_uuid: '',
      user_info: [
        {
          address: this.getuserinfodata[0].address,
          address_num: this.getuserinfodata[0].address_num,
          address_type: this.getuserinfodata[0].address_type,
          area: this.getuserinfodata[0].area,
          city: this.getuserinfodata[0].city,
          company_address: this.getuserinfodata[0].company_address,
          company_exist: this.getuserinfodata[0].company_exist,
          company_name: this.getuserinfodata[0].company_name,
          email: this.getuserinfodata[0].email,
          mobile: this.getuserinfodata[0].mobile,
          name: this.getuserinfodata[0].name,
          rec_address: this.getuserinfodata[0].rec_address,
          rec_address_type: this.getuserinfodata[0].rec_address_type,
          rec_area: this.getuserinfodata[0].rec_area,
          rec_city: this.getuserinfodata[0].rec_city,
          rec_company_address: this.getuserinfodata[0].rec_company_address,
          rec_company_name: this.getuserinfodata[0].rec_company_name,
          rec_email: this.getuserinfodata[0].rec_email,
          rec_info_exist: this.getuserinfodata[0].rec_info_exist,
          rec_mobile: this.getuserinfodata[0].rec_mobile,
          rec_name: this.getuserinfodata[0].rec_name,
          receipt_company_id: this.getuserinfodata[0].receipt_company_id,
          receipt_company_name: this.getuserinfodata[0].receipt_company_name,
          user_info_exist: this.getuserinfodata[0].user_info_exist,
        }
      ],
      edit_user_info: [
        {
          address: this.getuserinfodata[0].address,
          address_num: this.getuserinfodata[0].address_num,
          address_type: this.getuserinfodata[0].address_type,
          area: this.getuserinfodata[0].area,
          city: this.getuserinfodata[0].city,
          company_address: this.getuserinfodata[0].company_address,
          company_exist: this.getuserinfodata[0].company_exist,
          company_name: this.getuserinfodata[0].company_name,
          email: this.getuserinfodata[0].email,
          mobile: this.getuserinfodata[0].mobile,
          name: this.getuserinfodata[0].name,
          rec_address: this.getuserinfodata[0].rec_address,
          rec_address_type: this.getuserinfodata[0].rec_address_type,
          rec_area: this.getuserinfodata[0].rec_area,
          rec_city: this.getuserinfodata[0].rec_city,
          rec_company_address: this.getuserinfodata[0].rec_company_address,
          rec_company_name: this.getuserinfodata[0].rec_company_name,
          rec_email: this.getuserinfodata[0].rec_email,
          rec_info_exist: this.getuserinfodata[0].rec_info_exist,
          rec_mobile: this.getuserinfodata[0].rec_mobile,
          rec_name: this.getuserinfodata[0].rec_name,
          receipt_company_id: this.getuserinfodata[0].receipt_company_id,
          receipt_company_name: this.getuserinfodata[0].receipt_company_name,
          user_info_exist: this.getuserinfodata[0].user_info_exist,
        }
      ],
      area: {
        'area_lists': [],
        'area_detail': [],
      },
      show_area: {
        // order
        'order_is_first': true,
        'order_dialog': false,
        'order_has_company': false,
        'order_one_address': this.onlyoneaddress[0].order,
        // order address choose
        'order_company_show': false,
        'order_home_show': false,
        // rec
        'rec_is_first': true,
        'rec_dialog': false,
        'res_has_company': false,
        'rec_one_address': this.onlyoneaddress[0].rec,
        // rec address choose
        'rec_company_show': false,
        'rec_home_show': false,
      },
      maxaddress: {
        'order_max_address': '',
        'rec_max_address': '',
      },
      // 智販機
      is_vending_machine: this.getisvendingmachine,
    }
  },
  methods: {
    async getUserInfo() {
      // console.log(this.getuserinfodata);
      if (this.getuserinfodata !== undefined &&
        this.getuserinfodata.length > 0) {
        // 訂購人
        // 0: 沒有 1: 個人地址 2: 公司地址
        if (
          this.getuserinfodata[0].address_type === '1' &&
          this.getuserinfodata[0].address !== ''
        ) {
          this.show_area.order_is_first = false;
          this.maxaddress.order_max_address = this.user_info[0].city + this.user_info[0].area + this.user_info[0].address;
        } else if (this.getuserinfodata[0].address_type === '2') {
          this.show_area.order_is_first = false;
          this.maxaddress.order_max_address = `${this.user_info[0].company_address}(${this.user_info[0].company_name})`;
        } else {
          this.show_area.order_is_first = true;
          this.maxaddress.order_max_address = '';
        }
        // 儲存訂購人地址
        let orderinfo_data = [];
        orderinfo_data.push({
          'order_name': this.user_info[0].name,
          'order_address': this.maxaddress.order_max_address
        });
        // store vuex
        this.$store.commit({
          type: 'setOrderinfoData',
          orderinfoData: orderinfo_data,
        });
        await this.onOrderChange(this.edit_user_info[0].address_type);
        // 收貨人
        // 0: 沒有 1: 個人地址 2: 公司地址
        if (
          this.getuserinfodata[0].rec_address_type === '1' &&
          this.getuserinfodata[0].rec_address !== ''
        ) {
          this.show_area.rec_is_first = false;
          this.maxaddress.rec_max_address = this.edit_user_info[0].rec_city + this.edit_user_info[0].rec_area + this.edit_user_info[0].rec_address;
        } else if (this.getuserinfodata[0].rec_address_type === '2') {
          this.show_area.rec_is_first = false;
          this.maxaddress.rec_max_address = `${this.edit_user_info[0].rec_company_address}(${this.edit_user_info[0].rec_company_name})`;
        } else {
          this.show_area.rec_is_first = true;
          this.maxaddress.rec_max_address = '';
        }
        // 儲存收件人地址
        let recinfo_data = [];
        recinfo_data.push({
          'rec_address': this.maxaddress.rec_max_address
        });
        // store vuex
        this.$store.commit({
          type: 'setRecinfoData',
          recinfoData: recinfo_data,
        });
        await this.onRecChange(this.edit_user_info[0].rec_address_type);
        await this.getAreaInfo();
      } else {
        return false;
      }
    },
    onOrderChange(event) {
      if (event === "1") {
        this.show_area.order_company_show = false;
        this.show_area.order_home_show = true;
      } else if (event === "2") {
        this.show_area.order_company_show = true;
        this.show_area.order_home_show = false;
      } else {
        this.show_area.order_company_show = false;
        this.show_area.order_home_show = false;
      }
    },
    onRecChange(event) {
      if (event === "1") {
        this.show_area.rec_company_show = false;
        this.show_area.rec_home_show = true;
      } else if (event === "2") {
        this.show_area.rec_company_show = true;
        this.show_area.rec_home_show = false;
      } else {
        this.show_area.rec_company_show = false;
        this.show_area.rec_home_show = false;
      }
    },
    getAreaInfo() {
      this.axios({
        method: 'post',
        url: 'https://shopbkd.cheerlife.io/cheerlife/v1/recommend/city-area',
        data: {
          access_key: this.access_key,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.area.area_lists = response.data.area_lists;
            this.area.area_detail = response.data.area_detail;
          } else {
            alert(response.data.message);
            return false;
          }
        })
        .catch((error) => {
          alert(`status code: ${ error.response.status }`);
          alert(error.response.data);
        });
    },
    onOrderAreaChange() {
      this.edit_user_info[0].area = '';
    },
    onRecAreaChange() {
      this.edit_user_info[0].rec_area = '';
    },
    checkOrderAddress() {
      // console.log(this.edit_user_info);
      this.user_info = [];
      this.user_info.push(this.edit_user_info[0]);
      if (this.edit_user_info[0].address_type === '1') {
        this.maxaddress.order_max_address = this.edit_user_info[0].city + this.edit_user_info[0].area + this.edit_user_info[0].address;
      } else if (this.edit_user_info[0].address_type === '2') {
        this.maxaddress.order_max_address = `${this.edit_user_info[0].company_address}(${this.edit_user_info[0].company_name})`;
      } else {
        this.maxaddress.order_max_address = '';
      }
      // 修改訂購人地址
      this.$store.state.orderinfo.orderinfoData[0].order_name = this.edit_user_info[0].name;
      this.$store.state.orderinfo.orderinfoData[0].order_address = this.maxaddress.order_max_address;
      // change vuex data
      this.$store.state.userinfo.userinfoData[0].name = this.edit_user_info[0].name;
      this.$store.state.userinfo.userinfoData[0].email = this.edit_user_info[0].email;
      this.$store.state.userinfo.userinfoData[0].mobile = this.edit_user_info[0].mobile;
      this.$store.state.userinfo.userinfoData[0].address_type = this.edit_user_info[0].address_type;
      this.$store.state.userinfo.userinfoData[0].city = this.edit_user_info[0].city;
      this.$store.state.userinfo.userinfoData[0].area = this.edit_user_info[0].area;
      this.$store.state.userinfo.userinfoData[0].address = this.edit_user_info[0].address;
      this.$store.state.userinfo.userinfoData[0].company_name = this.edit_user_info[0].company_name;
      this.$store.state.userinfo.userinfoData[0].company_address = this.edit_user_info[0].company_address;
      // close dialog
      this.show_area.order_is_first = false;
      this.show_area.order_dialog = false;
    },
    sameOrderData(event) {
      // console.log(event);
      if (event === true) {
        // 顯示
        this.user_info[0].rec_address = this.user_info[0].address;
        this.user_info[0].rec_address_type = this.user_info[0].address_type;
        this.user_info[0].rec_area = this.user_info[0].area;
        this.user_info[0].rec_city = this.user_info[0].city;
        this.user_info[0].rec_company_address = this.user_info[0].company_address;
        this.user_info[0].rec_company_name = this.user_info[0].company_name;
        this.user_info[0].rec_email = this.user_info[0].email;
        this.user_info[0].rec_info_exist = this.user_info[0].user_info_exist;
        this.user_info[0].rec_mobile = this.user_info[0].mobile;
        this.user_info[0].rec_name = this.user_info[0].name;
        // 編輯
        this.edit_user_info[0].rec_address = this.user_info[0].address;
        this.edit_user_info[0].rec_address_type = this.user_info[0].address_type;
        this.edit_user_info[0].rec_area = this.user_info[0].area;
        this.edit_user_info[0].rec_city = this.user_info[0].city;
        this.edit_user_info[0].rec_company_address = this.user_info[0].company_address;
        this.edit_user_info[0].rec_company_name = this.user_info[0].company_name;
        this.edit_user_info[0].rec_email = this.user_info[0].email;
        this.edit_user_info[0].rec_info_exist = this.user_info[0].user_info_exist;
        this.edit_user_info[0].rec_mobile = this.user_info[0].mobile;
        this.edit_user_info[0].rec_name = this.user_info[0].name;
        // 顯示
        if (this.user_info[0].rec_address_type === '1') {
          this.maxaddress.rec_max_address = this.user_info[0].rec_city + this.user_info[0].rec_area + this.user_info[0].rec_address;
        } else if (this.user_info[0].rec_address_type === '2') {
          this.maxaddress.rec_max_address = `${this.user_info[0].rec_company_address}(${this.user_info[0].rec_company_name})`;
        } else {
          this.maxaddress.rec_max_address = '';
        }
        // 編輯
        if (this.edit_user_info[0].rec_address_type === '1') {
          this.maxaddress.rec_max_address = this.edit_user_info[0].rec_city + this.edit_user_info[0].rec_area + this.edit_user_info[0].rec_address;
        } else if (this.edit_user_info[0].rec_address_type === '2') {
          this.maxaddress.rec_max_address = `${this.edit_user_info[0].rec_company_address}(${this.edit_user_info[0].rec_company_name})`;
        } else {
          this.maxaddress.rec_max_address = '';
        }
        this.onRecChange(this.edit_user_info[0].address_type);
        // change vuex data
        this.$store.state.userinfo.userinfoData[0].rec_name = this.user_info[0].name;
        this.$store.state.userinfo.userinfoData[0].rec_email = this.user_info[0].email;
        this.$store.state.userinfo.userinfoData[0].rec_mobile = this.user_info[0].mobile;
        this.$store.state.userinfo.userinfoData[0].rec_address_type = this.user_info[0].address_type;
        this.$store.state.userinfo.userinfoData[0].rec_city = this.user_info[0].city;
        this.$store.state.userinfo.userinfoData[0].rec_area = this.user_info[0].area;
        this.$store.state.userinfo.userinfoData[0].rec_address = this.user_info[0].address;
        this.$store.state.userinfo.userinfoData[0].rec_company_name = this.user_info[0].company_name;
        this.$store.state.userinfo.userinfoData[0].rec_company_address = this.user_info[0].company_address;
        // 修改收件人地址
        this.$store.state.recinfo.recinfoData[0].rec_address = this.maxaddress.rec_max_address;
        // close dialog
        this.show_area.rec_is_first = false;
      } else {
        // console.log(this.$store.state.userinfo.userinfoData);
        // 顯示
        this.user_info[0].rec_address = '';
        this.user_info[0].rec_address_type = String(this.$store.state.userinfo.userinfoData[0].rec_address_type);
        this.user_info[0].rec_area = '';
        this.user_info[0].rec_city = '';
        this.user_info[0].rec_company_address = '';
        this.user_info[0].rec_company_name = '';
        this.user_info[0].rec_email = '';
        this.user_info[0].rec_info_exist = String(this.$store.state.userinfo.userinfoData[0].rec_info_exist);
        this.user_info[0].rec_mobile = '';
        this.user_info[0].rec_name = '';
        // 編輯
        this.edit_user_info[0].rec_address = '';
        this.edit_user_info[0].rec_address_type = String(this.$store.state.userinfo.userinfoData[0].rec_address_type);
        this.edit_user_info[0].rec_area = '';
        this.edit_user_info[0].rec_city = '';
        this.edit_user_info[0].rec_company_address = '';
        this.edit_user_info[0].rec_company_name = '';
        this.edit_user_info[0].rec_email = '';
        this.edit_user_info[0].rec_info_exist = String(this.$store.state.userinfo.userinfoData[0].rec_info_exist);
        this.edit_user_info[0].rec_mobile = '';
        this.edit_user_info[0].rec_name = '';
        // 顯示
        this.maxaddress.rec_max_address = '';
        this.onRecChange(this.edit_user_info[0].rec_address_type);
        // change vuex data
        this.$store.state.userinfo.userinfoData[0].rec_name = '';
        this.$store.state.userinfo.userinfoData[0].rec_email = '';
        this.$store.state.userinfo.userinfoData[0].rec_mobile = '';
        this.$store.state.userinfo.userinfoData[0].rec_city = '';
        this.$store.state.userinfo.userinfoData[0].rec_area = '';
        this.$store.state.userinfo.userinfoData[0].rec_address = '';
        this.$store.state.userinfo.userinfoData[0].rec_company_name = '';
        this.$store.state.userinfo.userinfoData[0].rec_company_address = '';
        // 修改收件人地址
        this.$store.state.recinfo.recinfoData[0].rec_address = '';
        // close dialog
        this.show_area.rec_is_first = true;
      }
    },
    checkRecAddress() {
      // console.log(this.edit_user_info);
      this.user_info = [];
      this.user_info.push(this.edit_user_info[0]);
      if (this.edit_user_info[0].rec_address_type === '1') {
        this.maxaddress.rec_max_address = this.edit_user_info[0].rec_city + this.edit_user_info[0].rec_area + this.edit_user_info[0].rec_address;
      } else if (this.edit_user_info[0].rec_address_type === '2') {
        this.maxaddress.rec_max_address = `${this.edit_user_info[0].rec_company_address}(${this.edit_user_info[0].rec_company_name})`;
      } else {
        this.maxaddress.rec_max_address = '';
      }
      // 修改收件人地址
      this.$store.state.recinfo.recinfoData[0].rec_address = this.maxaddress.rec_max_address;
      // change vuex data
      this.$store.state.userinfo.userinfoData[0].rec_name = this.edit_user_info[0].rec_name;
      this.$store.state.userinfo.userinfoData[0].rec_email = this.edit_user_info[0].rec_email;
      this.$store.state.userinfo.userinfoData[0].rec_mobile = this.edit_user_info[0].rec_mobile;
      this.$store.state.userinfo.userinfoData[0].rec_address_type = this.edit_user_info[0].rec_address_type;
      this.$store.state.userinfo.userinfoData[0].rec_city = this.edit_user_info[0].rec_city;
      this.$store.state.userinfo.userinfoData[0].rec_area = this.edit_user_info[0].rec_area;
      this.$store.state.userinfo.userinfoData[0].rec_address = this.edit_user_info[0].rec_address;
      this.$store.state.userinfo.userinfoData[0].rec_company_name = this.edit_user_info[0].rec_company_name;
      this.$store.state.userinfo.userinfoData[0].rec_company_address = this.edit_user_info[0].rec_company_address;
      // close dialog
      this.show_area.rec_is_first = false;
      this.show_area.rec_dialog = false;
    },
  },
  mounted() {
    this.getUserInfo();
  },
  watch: {
  },
};
</script>
<style scoped lang="sass">
  select
    -webkit-appearance: none
    -moz-appearance: none
    -ms-appearance: none
    appearance: none
    outline: 0
    box-shadow: none
    border: 0 !important
    background: #2c3e50
    background-image: none
  select::-ms-expand
    display: none
  .select_sty
    position: relative
    display: flex
    width: 20em
    height: 3em
    line-height: 3
    background: #2c3e50
    overflow: hidden
    border-radius: .25em
  select
    flex: 1
    padding: 0 .5em
    color: #fff
    cursor: pointer
  .select_sty::after
    content: '\25BC'
    position: absolute
    top: 0
    right: 0
    padding: 0 1em
    background: #34495e
    color: #ffffff
    cursor: pointer
    pointer-events: none
    -webkit-transition: .25s all ease
    -o-transition: .25s all ease
    transition: .25s all ease
  .select_sty:hover::after
    color: #f39c12
</style>
